import { DownloadSimple, FilePdf } from "@phosphor-icons/react";
import { api, act } from "@/lib/api";
import { Media } from "@/components/studio/kit";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

export const CarouselViewer = ({ p }) => {
  const ready = p.assets?.length && p.assets.every((a) => a.status === "ready");
  const pdf = async () => {
    const r = await act(() => api.get(`/studio/social/${p.id}/carousel.pdf`, { responseType: "blob" }));
    if (!r) return;
    const url = URL.createObjectURL(r);
    Object.assign(document.createElement("a"), { href: url, download: `carousel-${p.id.slice(0, 8)}.pdf` }).click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="bg-black" data-testid={`carousel-viewer-${p.id}`}>
      <Carousel className="relative">
        <CarouselContent className="ml-0">
          {(p.assets || []).map((a, i) => (
            <CarouselItem key={a.id} className="pl-0" data-testid={`carousel-slide-${p.id}-${i}`}>
              <Media a={a} className="w-full" style={{ aspectRatio: "4 / 5" }} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-2 h-7 w-7" data-testid={`carousel-prev-${p.id}`} />
        <CarouselNext className="right-2 h-7 w-7" data-testid={`carousel-next-${p.id}`} />
      </Carousel>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-2 py-2 text-xs">
        <span className="font-mono text-zinc-500 whitespace-nowrap">{p.assets?.filter((a) => a.status === "ready").length}/{p.assets?.length} slides</span>
        {ready && <button className="flex items-center gap-1 whitespace-nowrap text-zinc-400 hover:text-white" data-testid={`carousel-pdf-${p.id}`} onClick={pdf}><FilePdf /> PDF (LinkedIn)</button>}
        {ready && <div className="flex gap-2 w-full justify-center">{p.assets.map((a, i) => <a key={a.id} href={`${a.url}&download=1`} className="text-zinc-500 hover:text-white" data-testid={`carousel-dl-${p.id}-${i}`} title={`Slide ${i + 1}`}><DownloadSimple /></a>)}</div>}
      </div>
    </div>
  );
};
